import { render, staticRenderFns } from "./accountFllow.vue?vue&type=template&id=28be863a&scoped=true"
import script from "./accountFllow.vue?vue&type=script&lang=js"
export * from "./accountFllow.vue?vue&type=script&lang=js"
import style0 from "./accountFllow.vue?vue&type=style&index=0&id=28be863a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28be863a",
  null
  
)

export default component.exports